import request from './request'

export const menuList = (data) => {
  return request({
    url: '/v1/manager/user/menu/list',
    method: 'post',
    data: data
  })
}

// 获取菜单列表
export const getMenuTableList = (data) => {
  return request({
    url: '/v1/manager/system/menu/list',
    method: 'post',
    data: data
  })
}

// 添加菜单
export const addMenuList = (data) => {
  return request({
    url: '/v1/manager/system/menu/add',
    method: 'post',
    data: data
  })
}
// 获取菜单列表
export const updateMenuList = (data) => {
  return request({
    url: '/v1/manager/system/menu/change',
    method: 'post',
    data: data
  })
}
// 删除菜单信息
export const deleteMenuList = (data) => {
  return request({
    url: '/v1/manager/system/menu/delete',
    method: 'post',
    data: data
  })
}
